(function () {
  'use strict';

  var root = document.getElementById('sv-toronto-availability');
  if (!root) return;

  var variantDataElement = root.querySelector('[data-sv-toronto-variants]');
  var smsLink = root.querySelector('[data-sv-toronto-sms]');
  var productTitle = root.getAttribute('data-product-title') || document.title;
  var variants = {};
  var regionAllowsStore = false;

  try {
    variants = JSON.parse(variantDataElement ? variantDataElement.textContent : '{}');
  } catch (error) {
    return;
  }

  function currentVariantId() {
    var formVariant = document.querySelector(
      '#product-form form.product-form [name="id"], #product-info form.product-form [name="id"], form.product-form [name="id"]'
    );
    if (formVariant && formVariant.value) return String(formVariant.value);
    return new URL(window.location.href).searchParams.get('variant') || Object.keys(variants)[0] || '';
  }

  function placeCard() {
    var stock = document.querySelector('.sv-instock-banner, #product-form .stock-variant, #product-info .stock-variant');
    var purchaseControls = document.querySelector(
      '#product-form .wrap-quantity-add-cart, #product-info .wrap-quantity-add-cart'
    );
    var soldOut = document.querySelector('#product-form .out-stock, #product-info .out-stock');
    var target = purchaseControls || soldOut;

    if (stock && stock.parentNode) {
      stock.insertAdjacentElement('afterend', root);
    } else if (target && target.parentNode) {
      target.parentNode.insertBefore(root, target);
    }
  }

  function smsBody(variant) {
    var itemName = productTitle;
    if (variant && variant.title && variant.title !== 'Default Title') {
      itemName += ' — ' + variant.title;
    }
    return 'Hello, could you please confirm ' + itemName + ' is available in store?';
  }

  function updateSmsLink(variant) {
    if (!smsLink) return;
    var separator = /iPad|iPhone|iPod/.test(navigator.userAgent) ? '&' : '?';
    smsLink.href = 'sms:+16472440989' + separator + 'body=' + encodeURIComponent(smsBody(variant));
  }

  function updateVisibility() {
    var variant = variants[currentVariantId()];
    var shouldShow = regionAllowsStore && Boolean(variant && variant.available === true);
    root.hidden = !shouldShow;
    updateSmsLink(variant);
  }

  function listenForVariantChanges() {
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('#product-info, #product-form')) {
        window.setTimeout(updateVisibility, 0);
      }
    });
    document.addEventListener('click', function (event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest('#product-info .swatch, #product-form .swatch, variant-swatch-king')
      ) {
        window.setTimeout(updateVisibility, 25);
      }
    });
    window.addEventListener('popstate', updateVisibility);

    ['pushState', 'replaceState'].forEach(function (method) {
      var original = window.history[method];
      if (typeof original !== 'function') return;
      window.history[method] = function () {
        var result = original.apply(this, arguments);
        window.setTimeout(updateVisibility, 0);
        return result;
      };
    });
  }

  function resolveRegion() {
    var previewOverride = new URL(window.location.href).searchParams.get('sv_preview_store') === 'toronto';
    if (previewOverride) return Promise.resolve(true);

    var cacheKey = 'sv-toronto-region-v1';
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - cached.savedAt < 60 * 60 * 1000) {
        return Promise.resolve(cached.showStore === true);
      }
    } catch (error) {
      // Continue to the live region endpoint when storage is unavailable.
    }

    return fetch(root.getAttribute('data-region-endpoint'), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Region lookup failed');
        return response.json();
      })
      .then(function (result) {
        var showStore = result.showStore === true;
        try {
          window.sessionStorage.setItem(cacheKey, JSON.stringify({ showStore: showStore, savedAt: Date.now() }));
        } catch (error) {
          // Storage is an optimization, not a requirement.
        }
        return showStore;
      })
      .catch(function () {
        return false;
      });
  }

  placeCard();
  listenForVariantChanges();
  resolveRegion().then(function (showStore) {
    regionAllowsStore = showStore;
    updateVisibility();
  });
})();
